<template>
    <span :class="isMiniUku ? 'hideOnMiniUkuClose' : ''">
        <AppToolbarNewTask v-slot="{ on }">
            <template>
                <v-btn
                    fab
                    rounded
                    :color="$vuetify.breakpoint.mdAndUp ? 'new-task' : 'main'"
                    class="round-btn"
                    style="z-index: 5; position: fixed;"
                    :style="isMiniUku ? 'bottom: 134px; right: 28px;' : 'bottom: 44px; right: 15px;'"
                    v-on="on"
                    @click="newTask"
                >
                    <v-tooltip bottom>
                        <template v-slot:activator="{ tooltipOn }">
                            <icon
                                icon="Plus"
                                :on="on"
                                :class="{'white--text': !$vuetify.breakpoint.mdAndUp}"
                            />
                        </template>
                        <span>{{ $t("Add task") }}</span>
                    </v-tooltip>
                </v-btn>
            </template>
        </AppToolbarNewTask>
        <v-bottom-navigation
            v-if="$vuetify.breakpoint.smAndDown"
            ref="appnavdrawer"
            fixed
            style="height: 72px!important;"
            class="bottomNavigation"
            :class="isMiniUku ? 'mx-3' : 'px-3'"
        >
            <template v-for="(item, index) in items">
                <v-btn
                    :key="index"
                    value="item.name"
                    class="px-0 bottom-navigation-button"
                    :class="$route.name === item.route.name ? 'active' : ''"
                    :style="$vuetify.breakpoint.width < 385 ? { 'min-width': '62px' } : {}"
                    @click="navigate_route(item.route)"
                >
                    <span
                        :class="
                            $route.name === item.route.name ||
                                ($route.name === 'search' && item.route.name === 'dashboard')
                                ? 'primary--text'
                                : 'g4--text'
                        "
                    >
                        {{ item.title }}
                    </span>
                    <icon
                        :size="item.icon_size"
                        :color="
                            $route.name === item.route.name ||
                                ($route.name === 'search' && item.route.name === 'dashboard')
                                ? 'primary'
                                : item.icon_color
                        "
                        :icon="item.icon"
                    />
                </v-btn>
            </template>
            <v-btn
                v-if="showTimer"
                :class="['px-0 bottom-navigation-button timer-btn-mobile', status]"
                :style="$vuetify.breakpoint.width < 385 ? { 'min-width': '62px' } : {}"
                @click="openTask(taskId)"
            >
                <span>
                    {{ (totalDuration + runningDuration + tickingDuration) | format_time_duration }}
                </span>
                <v-icon>{{ status === "running" ? "mdi-pause-circle" : "mdi-play-circle-outline" }}</v-icon>
            </v-btn>
            <v-btn
                v-if="showTimer"
                disabled
                text
                class="px-0 pb-6"
                :style="$vuetify.breakpoint.width < 385 ? { 'min-width': '62px' } : {}"
            ></v-btn>
        </v-bottom-navigation>
    </span>
</template>

<script>
import { ref, computed } from "@vue/composition-api";
import { $t } from "../i18n";
import { Router } from "../composables/Router";
import AppToolbarNewTask from "../views/AppToolbar/AppToolbarNewTask";
import TaskModule from "../store/modules/task";
import AppModule from "../store/modules/app";
import TimerModule from "../store/modules/timer";
import { formatSysDate } from "../plugins/formatting";

export default {
    name: "AppNavigationDrawer",
    components: {
        AppToolbarNewTask
    },
    props: {
        drawer: {
            type: Boolean,
            default: true
        },
        dark: {
            type: Boolean,
            default: false
        },
        isMiniUku: {
            type: Boolean,
            default: false
        }
    },
    setup() {
        const router = Router();
        const items = ref([]);
        const { selected_date, openTask } = TaskModule();
        const { page_title } = AppModule();
        const timerModule = TimerModule();

        const showTimer = computed(function() {
            return (
                timerModule.task_id.value != null &&
                timerModule.task_id.value > 0 &&
                timerModule.task_status.value != "finished" &&
                timerModule.can_be_started.value
            );
        });

        let clientUrls = ["client_profile_tasks", "client_profile_notes"];
        const updateBottomMenu = function(currentRoute) {
            if (clientUrls.includes(currentRoute.name)) {
                items.value = [
                    {
                        title: $t("Tasks"),
                        name: "client_profile_tasks",
                        icon: "CheckSquare",
                        icon_size: "24",
                        icon_color: "var(--v-g4-base)",
                        route: { name: "client_profile_tasks" }
                    },
                    {
                        title: $t("Notes"),
                        name: "client_profile_notes",
                        icon: "Edit",
                        icon_size: "24",
                        icon_color: "var(--v-g4-base)",
                        route: { name: "client_profile_notes" }
                    }
                ];
            } else {
                items.value = [
                    {
                        title: $t("Tasks"),
                        name: "dashboard",
                        icon: "CheckSquare",
                        icon_size: "24",
                        icon_color: "var(--v-g4-base)",
                        route: { name: "dashboard" },
                        bookmark_name: "dashboard_search"
                    },
                    {
                        title: $t("Clients"),
                        name: "clients",
                        icon: "Contact",
                        icon_size: "24",
                        icon_color: "var(--v-g4-base)",
                        route: { name: "clients_list" },
                        bookmark_name: "client"
                    },
                ];
            }
        };

        let route = router.currentRoute;
        updateBottomMenu(route);

        router.beforeResolve(function(to, from, next) {
            updateBottomMenu(to);
            next();
        });

        const navigate_route = function(route) {
            page_title.value = null;
            let query = "";
            if (clientUrls.includes(route.name)) {
                query = this.$route.query;
            }
            return router
                .push({ name: route.name, query: query })
                .then(() => {
                    window.scrollTo(0, 0);
                    selected_date.value = formatSysDate(new Date());
                })
                .catch(() => {});
        };

        const newTask = function() {
            let props = {};

            if (router.currentRoute.name.startsWith("client_")) {
                props.client_id = parseInt(router.currentRoute.params.id);
            }

            openTask(0, props);
        };
        return {
            items,
            showTimer,
            openTask,
            taskId: timerModule.task_id,
            totalDuration: timerModule.total_duration,
            runningDuration: timerModule.running_duration,
            tickingDuration: timerModule.ticking_duration,
            status: timerModule.status,
            navigate_route,
            newTask
        };
    }
};
</script>
